import { endOfDay } from 'date-fns';

import { ModelTransformer } from '../common/common.model';

import { ObjectDateTransformer } from './coaching-insight.model';

export enum RosterType {
    SELF = 1,
    TEAM,
    OTHER,
}

export interface OverallCoverageItem {
    userId?: number;
    overallCoveragePct?: number;
    overallCoachingThresholdColour?: string;
    overallCoachingCoverageThresholdName?: string;
}

export interface PeriodCoverageItem {
    userId?: number;
    rosterType?: RosterType;
    startDate?: Date;
    endDate?: Date;
    coverageScore?: number;
    commitmentCoverageScore?: number;
    observationCoverageScore?: number;
    coverageColour?: string;
    commitmentCoverageColour?: string;
    observationCoverageColour?: string;
    coverageText?: string;
    commitmentCoverageText?: string;
    observationCoverageText?: string;
}

export interface CoverageDataDto {
    overall: OverallCoverageItem[];
    periods: PeriodCoverageItem[];
}

export class CoverageDataDtoTransformer
    implements ModelTransformer<CoverageDataDto, CoverageDataDto>
{
    transform(model: CoverageDataDto): CoverageDataDto {
        if (!model) {
            return null;
        }
        const transformer = new ObjectDateTransformer<CoverageDataDto>({
            periods: {
                startDate: 'L',
                endDate: 'L',
            },
        });
        transformer.transform(model);
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        model.overall &&
            model.overall.forEach((e) => {
                if (e.overallCoveragePct != null) {
                    e.overallCoveragePct /= 100;
                }
            });
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        model.periods &&
            model.periods.forEach((e) => {
                // TODO revise
                if (e.endDate) {
                    e.endDate = endOfDay(e.endDate);
                }

                if (e.coverageScore != null) {
                    e.coverageScore /= 100;
                }
                if (e.observationCoverageScore != null) {
                    e.observationCoverageScore /= 100;
                }
                if (e.commitmentCoverageScore != null) {
                    e.commitmentCoverageScore /= 100;
                }
            });
        return model;
    }
}
